import script from "./CitizenAnalyticsPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./CitizenAnalyticsPanel.vue?vue&type=script&lang=ts&setup=true"

import "./CitizenAnalyticsPanel.vue?vue&type=style&index=0&id=0a12ff99&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a12ff99"]])

export default __exports__